// 광고 배너 데이터 타입 정의
export interface AdBannerData {
  id: string;
  headerText: string;
  highlightText?: string;
  detailText: string;
  detailTextColor: string;
  price: string;
  bgColor: string;
  borderGradient: string;
  priceBg: string;
  priceTextColor: string;
  link: string;
}

// 트래킹 ID 가져오기
export const getTrkId = () => {
  return typeof window !== "undefined"
    ? localStorage.getItem("trkId")?.toLowerCase()
    : "";
};

// 모든 배너 데이터를 가져오는 함수
export const getAdBanners = (): AdBannerData[] => {
  // const trkId = getTrkId();

  return [
    // {
    //   id: "jungtong",
    //   headerText: "130페이지에 달하는",
    //   highlightText: "인생해설집 📜",
    //   detailText: "⚠ 안좋은 사주도 전부 작성됩니다.",
    //   detailTextColor: "#C85252",
    //   price: "35,000원",
    //   bgColor: "linear-gradient(90deg, #f8f8f8, #d6e9d5)",
    //   borderGradient: "linear-gradient(90deg, #a0b0af, #85a089)",
    //   priceBg: "#85a089",
    //   priceTextColor: "#ffffff",
    //   link: `https://sajutalktalk.dbcart.net/?g=${trkId}`,
    // },
    // {
    //   id: "couple",
    //   headerText: "이 사람과 나는 잘 맞을까? 🎯",
    //   detailText: "결혼운부터 자녀운, 재물운까지",
    //   detailTextColor: "#1A1E6D",
    //   price: "37,000원",
    //   bgColor: "linear-gradient(90deg, #F8F8F8 0%, #DFDDF8 100%)",
    //   borderGradient: "linear-gradient(90deg, #A7BDC0 0%, #938DC8 100%)",
    //   priceBg: "#938DC8",
    //   priceTextColor: "#ffffff",
    //   link: `https://couple.dbcart.net/?g=${trkId}`,
    // },
    // {
    //   id: "month",
    //   headerText: "9월 첫 구매 2,000원 쿠폰 이벤트 🍁",
    //   detailText: "가을맞이 혜택, 지금 바로 받아가세요 🍂",
    //   detailTextColor: "#5A3E2B",
    //   price: "2,000원 쿠폰",
    //   bgColor: "linear-gradient(90deg, #FFF6EA 0%, #FDE6D2 100%)",
    //   borderGradient: "linear-gradient(90deg, #D98C3D 0%, #8C5A2B 100%)",
    //   priceBg: "#C96B2C",
    //   priceTextColor: "#ffffff",
    //   link: `https://events-news.com/NDI3NA`,
    // },
    // {
    //   id: "love",
    //   headerText: "젠장 나만 또 솔로야??!!?",
    //   detailText: "솔로탈출의 기회를 알려드려요 🔑",
    //   detailTextColor: "#DD4A9A",
    //   price: "14,900원",
    //   bgColor: "linear-gradient(90deg, #F8F8F8 0%, #FFDCFA 100%)",
    //   borderGradient: "linear-gradient(90deg, #AA9BB1 0%, #DDADD7 100%)",
    //   priceBg: "#DDADD7",
    //   priceTextColor: "#ffffff",
    //   link: "https://events-news.com/MzA1",
    // },
    {
      id: "fall_in_love",
      headerText: "나만 연애 못해.. 내 팔자야... ㅠㅠ",
      detailText: "나에게만 힘든 연애,,, 사주에 정답이!",
      detailTextColor: "#E53935",
      price: "19,900원",
      bgColor: "linear-gradient(90deg, #F8F8F8 0%, #FFCDD2 100%)",
      borderGradient: "linear-gradient(90deg, #EF9A9A 0%, #E53935 100%)",
      priceBg: "#E53935",
      priceTextColor: "#ffffff",
      link: `https://sajutalktalk.com/product/fall_in_love`,
    },
  ];
};

// 특정 ID의 배너 데이터를 가져오는 함수
export const getAdBannerById = (id: string): AdBannerData | undefined => {
  return getAdBanners().find((banner) => banner.id === id);
};

// 운세 유형에 맞는 배너 매핑
export const luckTypeToAdBannerId: { [key: string]: string } = {
  money: "fall_in_love",
  love: "fall_in_love",
  job: "fall_in_love",
};
